export default __webpack_public_path__ + "static/media/cambridge.6c99a52e.webp";